module.exports = __webpack_public_path__ + "img/quietComfort-35-II.7a016560.jpg";